import Configs from "../config";
import { IProduct } from "../generated/Api";
import { localStorageGetItem } from "../utils/LocalStorage";

async function get(
  type: "STRIPE" | "THRIVECART" | "SHOPIFY" | "WORDPRESS"
): Promise<IProduct[] | null> {
  try {
    const token = localStorageGetItem("USER_TOKEN");
    const response = await fetch(
      `${Configs.SERVER_URL}/products/integration_all/${type}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    if (response.status === 200) {
      const responseJSON = await response.json();
      return responseJSON.data;
    }

    return null;
  } catch (err) {
    return null;
  }
}

async function create(product: IProduct): Promise<IProduct | null> {
  try {
    const token = localStorageGetItem("USER_TOKEN");
    const response = await fetch(`${Configs.SERVER_URL}/products`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ product }),
    });

    if (response.status === 200) {
      const responseJSON = await response.json();
      return responseJSON.data;
    }

    return null;
  } catch (err) {
    return null;
  }
}

async function remove(productId: string): Promise<boolean> {
  try {
    const token = localStorageGetItem("USER_TOKEN");
    const response = await fetch(
      `${Configs.SERVER_URL}/products/${productId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    if (response.status === 200) {
      return true;
    }

    return false;
  } catch (err) {
    return false;
  }
}

async function update(
  productId: string,
  product: Partial<IProduct>
): Promise<boolean> {
  try {
    const token = localStorageGetItem("USER_TOKEN");
    const response = await fetch(
      `${Configs.SERVER_URL}/products/${productId}`,
      {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({ product }),
      }
    );

    if (response.status === 200) {
      return true;
    }

    return false;
  } catch (err) {
    return false;
  }
}

export const ProductsAPI = {
  get,
  create,
  remove,
  update,
};
